/* custom cart count header start*/
setInterval(function(){ 
  $.getJSON('/cart.js', function(cart){ 
    var result = cart.item_count; 
    
      if(result != 0)
      { 
        document.getElementById("custom_cart_count").style.display = "block";
        document.getElementById("custom_cart_count").innerHTML = result;  
      }
      else
      { 
         document.getElementById("custom_cart_count").style.display = "none"; 
         document.getElementById("cartCount").style.display = "none"; 
      }
    
    }); 
}, 1000); 
/* custom cart count header end*/

 
/* Buy now reload when page fully loaded Start*/
window.onload = function() {
    reloadBuyNowButton();
};

function reloadBuyNowButton() {
    // Ensure that Shopify Payment Button script is initialized
    if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();  // Re-initialize the Buy Now button
    }
}
/* Buy now reload when page fully loaded END*/
